import { TRootState } from "@/store";
import { createSelector } from "reselect";

export const selectUser = (state: TRootState) => state.user;

export const selectUserConnected= createSelector(
  [selectUser],
  (user) => user.userConnected
);

